import { CellNavigationMode } from '../common/enums';
import { canEdit } from './columnUtils';
// above unfrozen cells, below frozen cells
const zCellMask = 1;
// above frozen cells, below header/filter/summary rows
const zFrozenCellMask = 2;
export function getSelectedDimensions({ selectedPosition: { idx, rowIdx }, columns, rowHeight, scrollLeft }) {
    if (idx < 0) {
        return { width: 0, left: 0, top: 0, height: rowHeight, zIndex: 1 };
    }
    const column = columns[idx];
    const { width } = column;
    const left = column.frozen ? column.left + scrollLeft : column.left;
    const top = rowIdx * rowHeight;
    const zIndex = column.frozen ? zFrozenCellMask : zCellMask;
    return { width, left, top, height: rowHeight, zIndex };
}
export function isSelectedCellEditable({ selectedPosition, columns, rows, onCheckCellIsEditable }) {
    const column = columns[selectedPosition.idx];
    const row = rows[selectedPosition.rowIdx];
    const isCellEditable = onCheckCellIsEditable ? onCheckCellIsEditable({ row, column, ...selectedPosition }) : true;
    return isCellEditable && canEdit(column, row);
}
export function getNextSelectedCellPosition({ cellNavigationMode, columns, rowsCount, nextPosition }) {
    if (cellNavigationMode !== CellNavigationMode.NONE) {
        const { idx, rowIdx } = nextPosition;
        const columnsCount = columns.length;
        const isAfterLastColumn = idx === columnsCount;
        const isBeforeFirstColumn = idx === -1;
        if (isAfterLastColumn) {
            if (cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
                const isLastRow = rowIdx === rowsCount - 1;
                if (!isLastRow) {
                    return {
                        idx: 0,
                        rowIdx: rowIdx + 1
                    };
                }
            }
            else if (cellNavigationMode === CellNavigationMode.LOOP_OVER_ROW) {
                return {
                    rowIdx,
                    idx: 0
                };
            }
        }
        else if (isBeforeFirstColumn) {
            if (cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
                const isFirstRow = rowIdx === 0;
                if (!isFirstRow) {
                    return {
                        rowIdx: rowIdx - 1,
                        idx: columnsCount - 1
                    };
                }
            }
            else if (cellNavigationMode === CellNavigationMode.LOOP_OVER_ROW) {
                return {
                    rowIdx,
                    idx: columnsCount - 1
                };
            }
        }
    }
    return nextPosition;
}
export function canExitGrid(event, { cellNavigationMode, columns, rowsCount, selectedPosition: { rowIdx, idx } }) {
    // When the cellNavigationMode is 'none' or 'changeRow', you can exit the grid if you're at the first or last cell of the grid
    // When the cellNavigationMode is 'loopOverRow', there is no logical exit point so you can't exit the grid
    if (cellNavigationMode === CellNavigationMode.NONE || cellNavigationMode === CellNavigationMode.CHANGE_ROW) {
        const atLastCellInRow = idx === columns.length - 1;
        const atFirstCellInRow = idx === 0;
        const atLastRow = rowIdx === rowsCount - 1;
        const atFirstRow = rowIdx === 0;
        const shift = event.shiftKey === true;
        return shift ? atFirstCellInRow && atFirstRow : atLastCellInRow && atLastRow;
    }
    return false;
}
//# sourceMappingURL=selectedCellUtils.js.map